<template>
  <div>
    <p class="badge badge-info">Задача на изменение цены/активности ({{ task.id }})</p>
    <table class="table table-sm mt-1">
      <tr v-for="t in getMainChanges()">
        <td>{{ $AllProjects[t.project_id].title }}<span v-if="t.qty > 1"> от {{ t.qty }} шт.</span></td>
        <td>{{ t.price }} ({{ t.taskProfit }} %)</td>
        <td>{{ t.actualPrice }} ({{ t.actualProfit }} %)</td>
      </tr>
      <tr v-if="newDiffRecords && newDiffRecords.projects">
        <td colspan="10">Добавлены дифф цены <strong>{{ newDiffRecords.projects }}</strong></td>
      </tr>
    </table>
  </div>
</template>

<script>

export default {
  props: ['task'],
  data() {
    return {
      newDiffRecords: null
    }
  },
  computed: {
    $AllProjects() {
      const sites = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        }, {});
      return sites;
    },
  },
  created() {
    const newDiffRecords = this.task.task_data.changes.filter((t) => !t.record_id);
    // console.log(newDiffRecords);
    const projects = {};
    if (newDiffRecords.length) {
      newDiffRecords.forEach((r) => projects[r.project_id] = true);
    }
    this.newDiffRecords = {
      projects: Object.keys(projects).reduce((acc, p, i) => {
        if (i > 0) acc += ', ';
        acc += this.$AllProjects[p].title;
        return acc;
      }, '')
    };
  },
  methods: {
    getMainChanges() {
      let records = this.task.task_data.changes.filter((c) => c.project_id === 1 || c.project_id === 7);
      if (!records.length) {
        records = this.task.task_data.changes.filter((c) => c.project_id === this.task.task_data.changes[0].project_id);
      }
      return records;
    }
  }
}

</script>

<style scoped>
table.table td {
  padding: 3px;
}
</style>
